import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorIsErrorWebsiteDownload = (state) => {
  return state[KEY_REDUCER_SW].isErrorWebsiteDownload;
};